import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { MainNavButton } from '../nav-button';

const COPY = defineMessages({
  DEVELOP: {
    id: 'Develop.develop',
    defaultMessage: 'Develop',
    description: '[Type: Label][Vis.: low] - Develop link in main navigation',
  },
});

const Develop = () => (
  <MainNavButton
    href="https://developer.surveymonkey.com"
    label={t(COPY.DEVELOP)}
  />
);

export default Develop;
export { Develop };
